module.exports = __webpack_public_path__ + "static/media/bannerDesktop@2x.496dfa1a.jpg";